import { render, staticRenderFns } from "./AssetDepartamentModal.vue?vue&type=template&id=3613f6dd"
import script from "./AssetDepartamentModal.vue?vue&type=script&lang=js"
export * from "./AssetDepartamentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports